import React, { FC, ReactElement } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactElement | ReactElement[];
}

const ArticleBlockFooter: FC<IProps> = ({ children }) => {
  return <footer className={css.articleBlock__footer}>{children}</footer>;
};

export default ArticleBlockFooter;
